import React, { memo } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

const MonthPicker = ({ date, onChange, prevMonth, nextMonth }) => {
  return (
    <div className="d-flex flex-center">
      <IconButton aria-label="arrow-left" color="primary" onClick={prevMonth}>
        <ChevronLeft />
      </IconButton>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          views={['year', 'month']}
          openTo="month"
          value={date}
          onChange={onChange}
          slotProps={{
            textField: {
              variant: 'standard',
            },
          }}
        />
      </LocalizationProvider>

      <IconButton aria-label="arrow-right" color="primary" onClick={nextMonth}>
        <ChevronRight />
      </IconButton>
    </div>
  );
};

MonthPicker.propTypes = {
  date: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  prevMonth: PropTypes.func,
  nextMonth: PropTypes.func,
};

export default memo(MonthPicker);
